import { Rpc, RpcGroup } from "effect/rpc";
import { Schema } from "effect";
import { KioskPolicyView } from "./kiosk-policy.schema";

/**
 * The read-only FrontDesk+ kiosk policy RPC group.
 *
 * Administration deliberately remains outside this kiosk-reachable surface. The
 * Bridge owns the handler while clients import only this contract package.
 *
 * @since 1.2.0
 * @example
 * ```ts
 * import { FrontDeskKioskPolicyRpcs } from "@ascleo/frontdesk-contracts/kiosk-policy/rpc";
 *
 * const operationCount = FrontDeskKioskPolicyRpcs.requests.size;
 * ```
 */
export class FrontDeskKioskPolicyRpcs extends RpcGroup.make(
  Rpc.make("FrontDeskKioskPolicyRead", {
    success: KioskPolicyView,
    payload: Schema.Struct({}),
  }),
) {}
